<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :params="{operationId: operationId}"

                    :title="$t('Devis') +' ' + $t('N°') + ' ' + (devis.numero ? devis.numero : 'N/A') + ' - ' + devis.artisan.toString"
                    />
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('devis.Numero') }}</div>
                  <div class="mt-2"> {{ getValue("numero") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('devis.Artisan') }}</div>
                  <div v-if="devis.artisan" class="mt-2"> {{ devis.artisan.toString }}</div>

                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ constructionLabel() }}</div>
                  <div v-if="devis.artisan" class="mt-2"> {{ nameDevis() }}</div>

                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Lot(s)') }}</div>
                  <div v-if="devis.artisan" class="mt-2"> {{ getLots() }}</div>

                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('devis.PrixTTC') }}</div>
                  <div class="mt-2"> {{ getValue("prixTTC") | formatEuro }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('devis.TauxTVA') }}</div>
                  <div class="mt-2"> {{ getValue("tauxTVA") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('devis.Status') }}</div>
                  <div v-if="devis.status" class="mt-2"> {{ $t(devis.status.text) }}</div>
                </div>
              </div>
              <div v-if="devis.documents && devis.documents.length > 0" class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('ContactDocuments') }}
                </div>
                <template v-for="document in devis.documents" class="row">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ document.name }}</div>
                    <b-link class="light-blue-color underline-text" v-on:click="getDocument(document.fileUrl)">
                      {{ document.fileName }}
                    </b-link>
                  </div>
                </template>
              </div>
              <div v-if="isConstruction" class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('SchedulePayment.date.constru') }}
                </div>
              </div>

              <div v-if="isConstruction" class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('schedulePayment.start.constru') }}</div>
                  <div class="mt-2"> {{ devis.operationConstruction.date | formatDate }}</div>
                </div>
              </div>

              <div v-if="isConstruction" class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('schedulePayment.end.constru') }}</div>
                  <div class="mt-2"> {{ devis.operationConstruction.endDate | formatDate }}</div>
                </div>
              </div>
              <div v-if="!isConstruction" class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('SchedulePayment.date.honoraire') }}
                </div>
              </div>

              <div v-if="!isConstruction" class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('schedulePayment.Date') }}</div>
                  <div class="mt-2"> {{ devis.operationHonoraire.date | formatDate }}</div>
                </div>
              </div>
            </div>
            <div v-if="devis.schedule && devis.schedule.id && devis.schedule.paiements.length > 0" class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('SchedulePayment.schedule') }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex flex-column">
                  <div class="bold-text"> {{ $t('SchedulePayment') }}</div>
                </div>
              </div>
              <div v-for="payment in devis.schedule.paiements" :key="payment.id" class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="mt-2"> {{ payment | formatPayment }}</div>
                </div>
              </div>
            </div>

            <div v-show="areFacturesLinked() === true" class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Factures') }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex flex-column">
                  <div class="bold-text mb-2"> {{ $t('Liste des factures') }}</div>
                </div>
              </div>
              <div v-for="payment in devis.schedule.paiements" :key="payment.id" class="col-12">
                <div v-if="payment.facture" class="mb-2">
                  <div @click="handleFactureClick(payment.facture)" class="cursor-pointer text-dark underline-text ">
                    {{ payment.facture.name }}
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :selectedItem="devis"
      controllerName="operationDevis"
      itemSingularName="devis"
      itemSingularNameUpp="Devis"
      @didDeleteItem="didDeleteDevis()">
    </Item-delete-modal>
  </div>
</template>

<script>
import api from "../../services/api"
import backArrow from "../../components/b122/BackArrow"
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue"

export default {
  name: "OperationDevisShow",


  components: {
    ItemDeleteModal,
    backArrow,
  },

  data() {
    return {
      operationDevisId: this.$route.params.operationDevisId,
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      devis: {},
      isConstruction: false,
    }
  },

  computed: {
    getValue() {
      return property => (this.devis[property] || this.devis[property] === false) ? this.devis[property] : 'N/A'
    },

  },

  filters: {
    formatDate: function (value) {
      if (!value) return 'N/A'
      value = value.split('-').reverse().join('/')
      return value
    },

    formatPayment: function (payment) {
      if (!payment) return 'N/A'
      let date = payment.date.split('-').reverse().join('/')
      return `${payment.name} le ${date} : ${payment.amount}€`
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      this.fetchDevis()
    },

    handleFactureClick(facture) {
      this.$router.push({
        name: 'OperationFactureShow',
        params: {
          factureId: facture.id,
          operationId: this.operationId
        }
      })
    },

    areFacturesLinked() {
      return this.devis.schedule.paiements.some(payment => payment.facture)
    },

    nameDevis() {
      if (this.isConstruction) {
        return this.devis.operationConstruction.name || 'N/A';
      } else {
        return this.devis.operationHonoraire.type || 'N/A';
      }
    },

    constructionLabel() {
      if (this.isConstruction) {
        return this.$t('Travaux')
      } else {
        return this.$t('Honoraire')
      }
    },

    getLots(){
      if(this.devis.operationConstruction && this.devis.operationConstruction.operationLots.length === 1){
        return this.devis.operationConstruction.operationLots[0]
      }

      else if(this.devis.operationConstruction && this.devis.operationConstruction.operationLots.length > 1){
        return this.devis.operationConstruction.operationLots.length + ' ' + 'lots'
      }

      else if (this.devis.operationConstruction && this.devis.operationConstruction.operation){
        return "Tous les lots"
      }

      else if (this.devis.operationHonoraire && this.devis.operationHonoraire.operationLots.length === 1){
        return this.devis.operationHonoraire.operationLots[0]
      }

      else if (this.devis.operationHonoraire && this.devis.operationHonoraire.operationLots.length > 1){
        return this.devis.operationHonoraire.operationLots.length + ' ' + 'lots'
      }

      else return 'N/A'
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus()
    },

    fetchDevis() {
      api
        .get(`/operationDevis/${this.operationDevisId}`)
        .then(response => {
          this.devis = response.data
          this.isConstruction = this.devis.operationConstruction && this.devis.operationConstruction.id
        })
        .catch((error) => {
          this.$router.push({
            name: 'OperationIndex',
          })
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationDevisEdit',
        params: {
          operationDevisId: this.operationDevisId,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteBtn() {
      if (this.devis && this.devis.schedule && this.devis.schedule.paiements.some(payment => payment.facture)) {
        this.$alert(this.$i18n.t('devis.cant.delete.facture.linked').toString()).then(() => {
        });
      } else {
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteDevis() {
      this.successToast((this.$i18n.t('Devis')) + ' "' + this.devis.numero + '" ' + this.$i18n.t('deleted'))
      this.$router.push({
        name: 'OperationDevisIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDevis/OperationDevisShow.vue